import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Auto-recover from an expired access token: on a 401, try a one-time refresh
// (using the refresh_token cookie) then replay the original request.
const SKIP_REFRESH = ["/auth/login", "/auth/register", "/auth/refresh", "/auth/session"];
let refreshPromise = null;

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config;
    const status = error.response?.status;
    const url = original?.url || "";
    const skip = SKIP_REFRESH.some((p) => url.includes(p));

    if (status === 401 && original && !original._retried && !skip) {
      original._retried = true;
      try {
        refreshPromise = refreshPromise || api.post("/auth/refresh");
        await refreshPromise;
        refreshPromise = null;
        return api(original);
      } catch (refreshErr) {
        refreshPromise = null;
        return Promise.reject(refreshErr);
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const STATUS_FLOW = [
  "Created",
  "Picked Up",
  "In Transit",
  "Out for Delivery",
  "Delivered",
];
export const EXCEPTION_STATUS = "Exception/Held";
export const ALL_STATUSES = [...STATUS_FLOW, EXCEPTION_STATUS];
export const PACKAGE_TYPES = ["Document", "Carton", "Pallet", "Fragile", "Hazardous"];

export const STATUS_STYLES = {
  Created: { chip: "bg-slate-800 text-slate-200 border-slate-600", dot: "bg-slate-400" },
  "Picked Up": { chip: "bg-blue-950 text-blue-300 border-blue-700/60", dot: "bg-blue-400" },
  "In Transit": { chip: "bg-amber-950 text-amber-300 border-amber-600/60", dot: "bg-amber-400 animate-pulse" },
  "Out for Delivery": { chip: "bg-orange-950 text-orange-300 border-orange-600/60", dot: "bg-orange-400 animate-pulse" },
  Delivered: { chip: "bg-emerald-950 text-emerald-300 border-emerald-600/60", dot: "bg-emerald-400" },
  "Exception/Held": { chip: "bg-rose-950 text-rose-300 border-rose-600/70", dot: "bg-rose-500 animate-pulse" },
};
